<template>
    <el-tabs :class="getPrimaryColor" v-model="activeTab" @tab-click="changeTab(activeTab)">
        <el-tab-pane v-for="(item, index) in items" :key="index" :label="item.label" :name="item.value" />
    </el-tabs>
</template>

<script>
export default {
    props: {
        isSponsor: {
            default: false,
            required: false
        }
    },
    data() {
        return {
            activeTab: this.$store.state.tabs.companyTab,
            /* tabItems : [ { label: 'Fornecedores', value: '1'}, { label: 'Financiadores', value: '0'}, { label: 'Compradores', value: '2'}, { label: 'Todos', value: '3'}], */
            tabItems : [{ label: 'Todos', value: '-1'}, { label: 'Pré-cadastro', value: '5'}, { label: 'Pendente', value: '0'}, { label: 'Análise', value: '2'}, { label: 'Revisão', value: '3'}, { label: 'Completo', value: '1'}, ],
        }
    },
    methods: {
        changeTab(tab) {
            this.$store.commit('tabs/setCompanyTab', tab)
            this.$emit('update-tab')
            return tab;
        }
    },
    computed: {
        items() {
            return this.isSponsor ? this.tabItems.filter(t => t.value !== '5') : this.tabItems
        }
    }
}
</script>

<style>

</style>
